import Cookies from "js-cookie";
import api from "./api";

 async function updateSessionLead(lead_id, payload) {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_BASE_URL}/tracking/sessions/add`,
        {
          ...payload,
          lead_id: lead_id,
        },
      );
      const data = response.data;
      Cookies.set(`${process.env.REACT_APP_SESSION_ID}`, String(data.data.id));
      Cookies.set(
        `${process.env.REACT_APP_LEAD_ID}`,
        String(data.data.lead_id),
      );
      Cookies.set(
        `${process.env.REACT_APP_SESSION_ID}_expires`,
        String(Date.now()),
      );
      return response;
    } catch (err) {
      console.error("Update session error:", err);
      return null;
    }
  }
  let sessionPromise = null;

export async function getOrCreateSession(payload) {
  if (sessionPromise) {
    return sessionPromise;
  }

  sessionPromise = (async () => {
    let sessionId = Cookies.get(process.env.REACT_APP_SESSION_ID);

    const expired =
      !Cookies.get(`${process.env.REACT_APP_SESSION_ID}_expires`) ||
      Date.now() -
        Number(
          Cookies.get(`${process.env.REACT_APP_SESSION_ID}_expires`)
        ) >
        3600000;

    if (!sessionId || expired) {
      const leadId =
        Cookies.get(process.env.REACT_APP_LEAD_ID_PLATFORM) ||
        Cookies.get(process.env.REACT_APP_LEAD_ID);

      const response = await updateSessionLead(leadId, payload);
      sessionId = response.data.data.id;
    }

    return sessionId;
  })();

  return sessionPromise;
}